<template>
  <div>
    <v-progress-circular
          v-if="enableButtons"
          style="margin-top: 15rem!important"
          :size="150"
          :width="20"
          color="primary"
          indeterminate
        ></v-progress-circular>    
    <v-row no-gutters v-else>
      <!-- card mensualidad -->
      <v-card
        elevation="25"
        color="rgba(255,255,255,1)"
        class="blue-grad mx-auto"
        style="
          margin: 1rem;
          border-top-left-radius: 2.5rem;
          border-top-right-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
          margin-bottom: 2rem;
        "
        max-width="300"
      >
        <v-container>
          <v-row dense>
            <v-col cols="12">
              <v-card-title style="font-size: 2rem; font-family: Poiret One">
                <b>●Mensualidad</b>
              </v-card-title>
              <div
                id="divider"
                style="
                  background-color: black;
                  height: 0.5rem;
                  width: 80%;
                  margin: auto;
                "
              ></div>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <b>Biblioteca de clases </b>
              </v-card-subtitle>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <br />
                <a
                  style="
                    font-size: 2.5rem;
                    color: black;
                    font-family: Poiret One;
                  "
                  ><b>$441 *Precio pago en línea</b></a
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-btn :disabled="enableButtons" rounded color="green" @click="getURLPay('Suscripción 1 mes', 44100)" >           
            $ Pagar
          </v-btn>
        </v-container>
      </v-card>


      <!-- card tres meses -->
      <v-card
        elevation="25"
        color="rgba(255,255,255,1)"
        class="blue-grad mx-auto"
        style="
          margin: 1rem;
          border-top-left-radius: 2.5rem;
          border-top-right-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
          margin-bottom: 2rem;
        "
        max-width="300"
      >
        <v-container>
          <v-row dense>
            <v-col cols="12">
              <v-card-title style="font-size: 2rem; font-family: Poiret One">
                <b>●3 Meses </b>
              </v-card-title>
              <div
                id="divider"
                style="
                  background-color: black;
                  height: 0.5rem;
                  width: 80%;
                  margin: auto;
                "
              ></div>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <b>Biblioteca de clases </b>
              </v-card-subtitle>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <br />
                <a
                  style="
                    font-size: 2.5rem;
                    color: black;
                    font-family: Poiret One;
                  ">
                  <b>$1139 *Precio pago en línea</b></a
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-btn :disabled="enableButtons" rounded color="green" @click="getURLPay('Suscripción 3 meses', 113900)" >           
            $ Pagar 
          </v-btn> 
        </v-container>
      </v-card>

      <!-- card dos meses -->
      <v-card
        elevation="25"
        color="rgba(255,255,255,1)"
        class="blue-grad mx-auto"
        style="
          margin: 1rem;
          border-top-left-radius: 2.5rem;
          border-top-right-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
          margin-bottom: 2rem;
        "
        max-width="300"
      >
        <v-container>
          <v-row dense>
            <v-col cols="12">
              <v-card-title style="font-size: 2rem; font-family: Poiret One">
                <b>●6 Meses </b>
              </v-card-title>
              <div
                id="divider"
                style="
                  background-color: black;
                  height: 0.5rem;
                  width: 80%;
                  margin: auto;
                "
              ></div>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <b>Biblioteca de clases </b>
              </v-card-subtitle>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <br />
                <a
                  style="
                    font-size: 2.5rem;
                    color: black;
                    font-family: Poiret One;
                  "
                  ><b>$2180 *Precio pago en línea</b></a
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
          <v-btn :disabled="enableButtons" rounded color="green" @click="getURLPay('Suscripción 6 meses', 218000)" >           
            $ Pagar
          </v-btn>
        </v-container>
      </v-card>

     
    </v-row>
  </div>
</template>
<script>


export default {
  data() {
    return {
      urlPayment: "",
      enableButtons: false
    };
  },
  mounted() {
    this.enableButtons == true || this.enableButtons != true ? this.enableButtons = false : this.enableButtons = false
  },
  methods: {
    async getURLPay(item, price) {
      this.enableButtons = true;
      const data = {
        email: this.$store.state.authModule.user.email,
        fullname: this.$store.state.authModule.name +" "+this.$store.state.authModule.lastName,
        item: item,
        price: price

      }
      fetch('https://barrepro-api.onrender.com/createCustomer',{
        method: 'POST', // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        headers:{
          'Content-Type': 'application/json'
        }}
      ).then(function(response) {        
          return response.json()        
      }).then(function(data) {
        window.open(data.url, "_self");
      });
    }
  }
};
</script>
<style scoped>
 
</style>



// WEBPACK FOOTER //
// src/components/pricing_page_components/pricing_card_renew.vue